export const environment = {
  production: true,
  apiUrl: 'https://planard.api.smartmaplesoftware.com/api', //'http://api2.mehmetkurtipek.com/api',
  hshPwd: 'e10adc3949ba59abbe56e057f20f883e',
  hshPwd1: '5232523ab4dce3a8cb6191ead18068f3',
  authority: 'https://planard.identity.smartmaplesoftware.com/', //'http://devacc.mapleyazilim.com/',
  callback: 'https://planard.smartmaplesoftware.com/' //http://dev.planard.com/'
};

